import { type Category } from './categories';

export type Game = {
  rows: Category[];
  cols: Category[];
};

export const saturdayGames: Game[] = [
  {
    rows: [
      "Songs with person's name in title",
      'Not about love/not about romantic relationships',
      'Lyrics that refer to the telephone',
    ],
    cols: [
      'Paul plays the drums',
      'Real place named in lyrics',
      'Food / meals / drink in lyrics',
    ],
  },
  {
    cols: [
      'Days of the week in the lyrics',
      'Jewellery or items of clothing in lyrics',
      '3 word title',
    ],
    rows: [
      'All four Beatles (and no one else) on the recording',
      'Real place named in lyrics',
      'Features orchestral strings',
    ],
  },
  {
    cols: [
      'More than one time signature',
      'Jewellery or items of clothing in lyrics',
      '3 word title',
    ],
    rows: [
      'All four Beatles (and no one else) on the recording',
      'Real place named in lyrics',
      'Features orchestral strings',
    ],
  },
  {
    cols: [
      'Number(s) in title',
      'Album closers',
      'The word "girl" in the lyrics',
    ],
    rows: [
      'All four Beatles (and no one else) on the recording',
      '3 word title',
      'The Beatles played it on tour or in a live performance',
    ],
  },
  {
    cols: [
      'Songs with only one Beatle',
      'Verb in the title',
      'George lead vocal',
    ],
    rows: [
      '1 word title',
      'The word "girl" in the lyrics',
      'Features brass instruments',
    ],
  },
  {
    cols: [
      'Not Lennon—McCartney',
      'Not about love/not about romantic relationships',
      'Food / meals / drink in lyrics',
    ],
    rows: [
      'Word(s) repeat in title',
      'Body of water in the lyrics',
      'Features brass instruments',
    ],
  },
  {
    cols: [
      'The word "baby" or "babe" in the lyrics',
      'Released 1970',
      "Songs with person's name in title",
    ],
    rows: [
      'All four Beatles (and no one else) on the recording',
      'Animal in lyrics',
      'Not about love/not about romantic relationships',
    ],
  },
  {
    cols: [
      '2 word title',
      'Released 1967',
      'Not about love/not about romantic relationships',
    ],
    rows: [
      'Food / meals / drink in lyrics',
      'B-side of UK single',
      '"Heart" in the lyrics',
    ],
  },
  {
    cols: ['1 word title', 'Animal in lyrics', 'Verb in the title'],
    rows: [
      'Not about love/not about romantic relationships',
      'Released 1968',
      'Features orchestral strings',
    ],
  },
  {
    cols: [
      'Features brass instruments',
      'The word "girl" in the lyrics',
      'Features orchestral strings',
    ],
    rows: [
      'Songs that mention real public figures by name',
      'Body of water in the lyrics',
      'Not Lennon—McCartney',
    ],
  },
  {
    cols: [
      'Songs with an Indian instrument',
      'Features orchestral strings',
      'All four Beatles (and no one else) on the recording',
    ],
    rows: [
      'Not about love/not about romantic relationships',
      'Songs over 4 minutes',
      'More than one time signature',
    ],
  },
  {
    cols: [
      'Ringo lead vocal',
      'Songs that begin with a count-in',
      'Side A, Track 5',
    ],
    rows: [
      'The word "girl" in the lyrics',
      'Verb in the title',
      'All four Beatles (and no one else) on the recording',
    ],
  },
];
